import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconTablet', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M12 13.6H4.00002V2.4H12V13.6ZM3.20002 0.799999H12.8C13.2424 0.799999 13.6 1.1576 13.6 1.6V14.4C13.6 14.8424 13.2424 15.2 12.8 15.2H3.20002C2.75762 15.2 2.40002 14.8424 2.40002 14.4V1.6C2.40002 1.1576 2.75762 0.799999 3.20002 0.799999ZM8.80003 12C8.80003 12.4424 8.44243 12.8 8.00003 12.8C7.55763 12.8 7.20003 12.4424 7.20003 12C7.20003 11.5576 7.55763 11.2 8.00003 11.2C8.44243 11.2 8.80003 11.5576 8.80003 12Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M15 3V17H5V3H15ZM4 1H16C16.553 1 17 1.447 17 2V18C17 18.553 16.553 19 16 19H4C3.447 19 3 18.553 3 18V2C3 1.447 3.447 1 4 1ZM11 15C11 15.553 10.553 16 10 16C9.447 16 9 15.553 9 15C9 14.447 9.447 14 10 14C10.553 14 11 14.447 11 15Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M18 20.4H5.99998V3.6H18V20.4ZM4.79998 1.2H19.2C19.8636 1.2 20.4 1.7364 20.4 2.4V21.6C20.4 22.2636 19.8636 22.8 19.2 22.8H4.79998C4.13638 22.8 3.59998 22.2636 3.59998 21.6V2.4C3.59998 1.7364 4.13638 1.2 4.79998 1.2ZM13.2 18C13.2 18.6636 12.6636 19.2 12 19.2C11.3364 19.2 10.8 18.6636 10.8 18C10.8 17.3364 11.3364 16.8 12 16.8C12.6636 16.8 13.2 17.3364 13.2 18Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M24 27.2H7.99999V4.8H24V27.2ZM6.39999 1.6H25.6C26.4848 1.6 27.2 2.3152 27.2 3.2V28.8C27.2 29.6848 26.4848 30.4 25.6 30.4H6.39999C5.51519 30.4 4.79999 29.6848 4.79999 28.8V3.2C4.79999 2.3152 5.51519 1.6 6.39999 1.6ZM17.6 24C17.6 24.8848 16.8848 25.6 16 25.6C15.1152 25.6 14.4 24.8848 14.4 24C14.4 23.1152 15.1152 22.4 16 22.4C16.8848 22.4 17.6 23.1152 17.6 24Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));